<app-loading-spinner *ngIf="isLoading" [inline]="1"></app-loading-spinner>
<nav class="subnav">
  <div class="prev">
    <a [routerLink]="['/activity','fit','videos',+level-1,0]"  *ngIf="level>1"
      ><span class="icon-wrap"
        ><fa-icon [icon]="['fas', 'circle-arrow-left']"></fa-icon></span
    ></a>
  </div>
  <h2>Level {{ level }} Videos</h2>
  <div class="next">
    <a [routerLink]="['/activity','fit','videos',+level+1,0]"  *ngIf="level<3">
      <span class="icon-wrap"
        ><fa-icon [icon]="['fas', 'circle-arrow-right']"></fa-icon></span
    ></a>
  </div>
</nav>

<div class="container container-inner container-content" *ngIf="video">
  <div class="row">
    <div class="col">
      <video
        width="100%"
        style="max-height: 80vh"
        controls
        preload
        class="mt-4 fade-in mb-4"
        controlsList="nodownload"
        [src]="getVideo(video.video)"
        autoplay
        poster="/assets/img/video-poster.jpg"
      ></video>
      <h3 class="text-center mt-1 mb-4">{{ video.title }}</h3>
    </div>
  </div>
  <div class="row" *ngIf="levelVideos[level]">
    <div class="col-12">
      <h4 class="text-center">More Level {{ level }} Videos</h4>
      <div class="card mt-3 mb-4 bg-light rounded">
        <div class="card-body">
          <ul class="link-list">
            <li *ngFor="let _video of levelVideos[level]; let index = index">
              <a
                [routerLink]="['/activity', 'fit', 'videos', level, index]"
                [ngClass]="{ active: videoId == index }"
              >
                <span class="icon-wrap more-link"
                  ><fa-icon [icon]="['fas', 'circle-play']"></fa-icon
                ></span>
                <span class="link-label">{{ _video.title }}</span>
                <span class="icon-wrap more-link duo-primary-dark"
                  ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
                ></span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
